import { useContext } from 'react'
import { Moon, Sun } from 'lucide-react'
import { ThemeContext } from '../../contexts/theme'
import styles from './ThemeToggle.module.css'

export function ThemeToggle() {
  const { themeName, toggleTheme } = useContext(ThemeContext)
  
  return (
    <button
      type='button'
      onClick={toggleTheme}
      className={styles.toggle}
      aria-label={`Switch to ${themeName === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${themeName === 'dark' ? 'light' : 'dark'} mode`}
    >
      {themeName === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  )
}


